import { EHouseLineType } from 'shared/json_query';

import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IHouseLineBuildingTagType = 'advanced-house-line-building';

export interface IHouseLineBuildingTag {
  type: 'advanced-house-line-building';
  value: EHouseLineType;
}

function isHouseLineBuildingTag(tag: TTag): tag is IHouseLineBuildingTag {
  return tag.type === IHouseLineBuildingTagType;
}

export const houseLineBuildingTag: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.building_house_line_type && jsonQuery.building_house_line_type.value;

    let nextTags = tags.filter(
      tag => tag.type !== IHouseLineBuildingTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EHouseLineType) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IHouseLineBuildingTag => isHouseLineBuildingTag(tag) && tag.value === value,
            () => ({ type: IHouseLineBuildingTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
